import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { baseQuery, endpoints, formatErrors } from 'utils/api/endpoints';
import { RenderLogsState, GetRenderLogsParams, GetRenderLogsResponse } from './types';

export const initialState: RenderLogsState = {
    logs: [],
    loading: false,
    error: undefined,
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        pages: 0,
    },
};

const renderLogsSlice = createSlice({
    name: 'renderLogs',
    initialState,
    reducers: {},
});

export const renderLogsApi = createApi({
    reducerPath: 'renderLogsApi',
    baseQuery,
    tagTypes: ['RenderLogs'],
    endpoints: (builder) => ({
        getRenderLogs: builder.query<GetRenderLogsResponse, GetRenderLogsParams>({
            query: (params) => ({
                url: endpoints.renderLogs.url,
                method: endpoints.renderLogs.method,
                params: {
                    page: params.page || 1,
                    limit: params.limit || 10,
                    ...(params.userId && { userId: params.userId }),
                    ...(params.productId && { productId: params.productId }),
                    ...(params.companyId && { companyId: params.companyId }),
                    ...(params.search && { search: params.search }),
                    ...(params.status && { status: params.status }),
                    ...(params.startDate && { startDate: params.startDate }),
                    ...(params.endDate && { endDate: params.endDate }),
                },
            }),
            transformResponse(baseQueryReturnValue: any, meta, arg) {
                return baseQueryReturnValue?.data;
            },
            transformErrorResponse(baseQueryReturnValue, meta, arg) {
                return formatErrors(baseQueryReturnValue.data);
            },
            providesTags: ['RenderLogs'],
        }),
    }),
});

export const { useGetRenderLogsQuery } = renderLogsApi;

export const useRenderLogsSlice = () => {
    useInjectReducer({ key: 'renderLogs', reducer: renderLogsSlice.reducer });
    useInjectReducer({ key: renderLogsApi.reducerPath, reducer: renderLogsApi.reducer });

    return {
        actions: renderLogsSlice.actions,
        ...renderLogsApi.endpoints,
        useGetRenderLogsQuery,
    };
};

export default renderLogsSlice.reducer;
